// "descricao" do evento: formato novo = array [{ idUsuario, texto, data }], formato antigo = string.
const SEPARADOR = "\n\n";

export function descricaoParaArray(descricao) {
    if (Array.isArray(descricao)) return descricao.filter(d => d && String(d.texto || "").trim());
    const texto = String(descricao || "").trim();
    return texto ? [{ texto }] : [];
}

export function descricaoParaTexto(descricao) {
    return descricaoParaArray(descricao).map(d => d.texto).join(SEPARADOR);
}

// Monta o array a enviar ao banco: preserva o histórico original e acrescenta o que foi digitado a mais.
export function montarDescricao(textoAtual, descricaoOriginal, idUsuario) {
    const original = descricaoParaArray(descricaoOriginal);
    const atual = String(textoAtual || "").trim();
    const textoOriginal = descricaoParaTexto(original);

    if (atual === textoOriginal) return original;

    const novoEntry = (texto) => ({ ...(idUsuario ? { idUsuario } : {}), texto, data: new Date() });

    if (original.length > 0 && atual.startsWith(textoOriginal)) {
        const restante = atual.slice(textoOriginal.length).trim();
        return restante ? [...original, novoEntry(restante)] : original;
    }

    return atual ? [novoEntry(atual)] : [];
}
